import BackIcon from '../../assets/logo/BackIcon';
import { SCREENS } from '../../services/exports/Constants';
import useTheme from '../../hooks/ui/useTheme';
import useScreenType from '../../hooks/utility/useScreenType';
import { useTranslation } from 'react-i18next';
import useNavigate from '../../hooks/navigation/useNavigate';
import useConfig from '../../hooks/ui/useConfig';
import UserBadge from '../profile/UserBadge';

interface Props {
  goBack?: () => void;
  showLogoOnMobile?: boolean;
}

export default function CheckoutNavBar(props: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Navigation:CheckoutNavBar' });

  const { showLogoOnMobile, goBack } = props;

  const theme = useTheme();
  const { navigate } = useNavigate();
  const { logo_url } = useConfig();
  const { isDesktop } = useScreenType();

  function _goBack() {
    if (goBack) {
      return goBack();
    }

    navigate(SCREENS.HOME_SCREEN);
  }

  function renderLeftContainer() {
    function getDescription(): string {
      if (isDesktop) {
        return t('back');
      }

      return t('menu');
    }

    return (
      <button className={leftContainer} onClick={_goBack} data-test="checkout-nav-bar-back-button">
        <div>
          <BackIcon className="h-4 !w-4 mr-xs" color={theme.color.black.DEFAULT} />
        </div>
        <div className="flex-none">
          <p className="mr-xs">{getDescription()}</p>
        </div>

        {logo_url && (
          <div className="shrink">
            <img src={logo_url} alt="Logo" className={companyLogoStyle} />
          </div>
        )}
      </button>
    );
  }

  function renderCenterContainer() {
    return (
      <div className={centerContainer}>
        {logo_url && showLogoOnMobile && !isDesktop && (
          <button onClick={goBack}>
            <img src={logo_url} alt="Logo" className={companyLogoMobileStyle} />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={container}>
      {renderLeftContainer()}
      {renderCenterContainer()}
      <UserBadge className="justify-end" />
    </div>
  );
}

const container = 'w-full z-10 py-md items-center grid grid-cols-5 lg:px-lg px-md bg-white border-b';

const leftContainer = 'col-span-1 flex flex-row items-center';

const centerContainer = 'col-span-3 flex justify-center items-center';

const companyLogoStyle = 'mr-4 h-12 lg:flex hidden object-contain';

const companyLogoMobileStyle = ' h-[36px]';
